import React from 'react'
import CustomModal from 'components/global/CustomModal'
import { eventShatStore } from 'state/event/eventChat'
import CustomModalFooter from 'components/global/CustomModalFooter'
import useFormSubmit from 'helper/Hooks/formSubmit'
import LeagueChatContent from './LeagueChatContent'
import { Person } from 'types/globalTypes'

interface LeagueChatModalProps {
  leagueId: string
  participants: Person[]
}

const LeagueChatModal: React.FC<LeagueChatModalProps> = ({
  leagueId,
  participants,
}) => {
  const { form, handleSubmit } = useFormSubmit()
  const { chatModalVisible, setChatModalVisible } = eventShatStore(store => ({
    chatModalVisible: store.chatModalVisible,
    setChatModalVisible: store.setChatModalVisible,
  }))

  return (
    <CustomModal
      openModal={chatModalVisible}
      closeModal={setChatModalVisible}
      title="Contact attendees"
      footer={
        <CustomModalFooter
          multibutton={true}
          btnAlignment="justify-end"
          btnText="Cancel,Send"
          onSubmit={handleSubmit}
          closeModal={setChatModalVisible}
        />
      }
    >
      <LeagueChatContent
        form={form}
        leagueId={leagueId}
        participants={participants}
      />
    </CustomModal>
  )
}

export default LeagueChatModal
